import Vue from 'vue'

export default {
  SET_SURVEY_DATA: (state, { survey, surveyId }) => {
    Vue.set(state, 'dataSet', survey.dataSet)
    state.survey.surveyName = survey.surveyName
    state.survey.surveyId = surveyId
    state.survey.disallowBackButton = survey.disallowBackButton
    state.survey.showTestResults = survey.showTestResults
    state.survey.testResults = survey.testResults
    state.survey.customThankYouPage = survey.thankYouPage
    state.survey.current = 0
    state.survey.status = 'started'
    state.survey.questionCount = survey.dataSet.length
    state.responses = []
  },

  SET_SITE_DATA: (state, { site, siteId }) => {
    Vue.set(state.site, 'pages', site.pages)
    state.site.isLoaded = true
  },

  SET_TEST_RESULTS_DATA: (state, { data }) => {
    state.testResults = data
  },
  STORE_USER_PROFILE: (state, { profile, profileId }) => {
    state.user.profileId = profileId
    state.user.profile = profile
  },
  BROWSER_REPORT: (state, { report }) => {
    state.survey.browserReport = report
  },
  STORE_RESPONSE: (state, { qid, response }) => {
    state.responses[qid] = response
  },
  SET_CURRENT: (state, { current }) => {
    state.survey.current = current
  },
  SET_ACTUAL_QID: (state, { qid }) => {
    state.survey.qid = qid
  },
  SET_SURVEY_STATUS: (state, { status }) => {
    state.survey.status = status
    if (status !== 'started') {
      state.survey.current = 0
    }
  },
  CLEAR_RESPONSES: (state) => {
    state.responses = []
    state.survey.status = 'sent'
  },
  CLEAR_FORM: (state) => {
    state.responses = []
    state.survey.current = null
    state.survey.status = 'started'
    state.survey.surveyId = null
    state.survey.current = 0
  },
  RESTART_FORM: (state) => {
    state.responses = []
    state.survey.current = 0
    state.survey.status = 'started'
  },
  STORE_TEST_RESULT: (state, { weightedTestResults }) => {
    state.survey.weightedTestResults = weightedTestResults
  }
}
